import React, {useState} from "react";
import {Box, Stack, Typography, IconButton, Button} from "@mui/material";
import {IconChevronRight, IconCopy,IconCheck} from "@tabler/icons-react";
import {copyToClipboard} from "../../../../utils/functions";
import {toast} from "react-toastify";
import {green} from "@mui/material/colors";



export const ResultPanel = ({result}) => {
  const [expanded, setExpanded] = useState(false);
  const [isCopied,setCopied]=useState(false);

  const copyHandler = async (result) => {
    try {
      await copyToClipboard(result.result);
      toast.success("Text copied.");
      setCopied(true);
      setTimeout(()=>(setCopied(false)),1500)
    } catch (e) {
      toast.error("Failed to copy.");
    }
  };
  const content = typeof result === "string" ? (
    <Typography fontSize={12} sx={{whiteSpace: "pre-wrap", wordBreak: "break-word"}}>{result}</Typography>
  ) : typeof result === "object" ? (
    Object.entries(result).map(([key, val]) => (
      <Box key={key} sx={{mb: 1}}>
        <Typography fontSize={11} fontWeight={700} color="text.secondary" mb={0.25}>{key}</Typography>
        <Typography fontSize={12} sx={{whiteSpace: "pre-wrap", wordBreak: "break-word"}}>
          {typeof val === "string" ? val : JSON.stringify(val, null, 2)}
        </Typography>
      </Box>
    ))
  ) : (
    <Typography fontSize={12}>{String(result)}</Typography>
  );

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0.75}>
        <Typography fontSize={11} fontWeight={700} textTransform="uppercase" letterSpacing={0.5} color="text.secondary">
          Result
        </Typography>
        <Stack direction="row" alignItems="center" gap={1}>

          <Button
            size="small"
            onClick={() => setExpanded(v => !v)}
            endIcon={
              <IconChevronRight size={13} style={{
                transition: "transform 0.2s",
                transform: expanded ? "rotate(-90deg)" : "rotate(90deg)",
              }}/>
            }
            sx={{fontSize: 11, mx: 2, mb: 1, textTransform: "none", color: "text.secondary", p: 0, minWidth: 0}}
          >
            {expanded ? "Hide Result" : "Show Result"}
          </Button>

        </Stack>
      </Stack>
      <Box sx={{position: "relative", bgcolor: "grey.100", borderRadius: 1}} className={"border-shadow"}>
        <IconButton size="small" sx={{position: "absolute", top: 8, right: 8, p: 0.5, zIndex:2}}
                    onClick={() => copyHandler(result)}>
          {isCopied ? <IconCheck color="green" size={14} /> : <IconCopy size={14} />}
        </IconButton>
        <Box sx={{
          position: "relative",
          p: 1.5,
          borderRadius: 1,
          maxHeight: expanded ? "none" : 180,
          overflow: "hidden"
        }}>
          <Box sx={{fontFamily: "monospace"}}>{content}</Box>
          {!expanded && (
            <Box sx={{
              position: "absolute", bottom: 0, left: 0, right: 0, height: 60,
              background: "linear-gradient(transparent, #f5f5f5)",
              borderRadius: "0 0 4px 4px",
              pointerEvents: "none",
            }}/>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export const DescriptionPanel = ({description, open}) => {
  const isLong = description?.length > 220;
  const clean = description.trim().replace(/\s+/g, " ");
  const displayed = open || !isLong ? clean : clean.slice(0, 220) + "...";

  return (
    <Box sx={{mt: 1.25}}>
      <Typography fontSize={12} noWrap={open ? undefined : true} color="text.secondary">
        {displayed}
      </Typography>
    </Box>
  );
};

export const SectionHeader = ({label, count, open, onToggle}) => (
  <Stack
    direction="row" alignItems="center" gap={1}
    onClick={onToggle}
    sx={{cursor: "pointer", userSelect: "none", mb: open ? 1.5 : 0}}
  >
    <Typography fontSize={15} fontWeight={700} textTransform="uppercase" letterSpacing={0.5} color="text.secondary">
      {label} ({count})
    </Typography>
    <IconChevronRight size={16} style={{
      transition: "transform 0.2s",
      transform: open ? "rotate(90deg)" : "rotate(0deg)",
      opacity: 0.5,
    }}/>
  </Stack>
);